import { PageEvent } from '@angular/material/paginator';
import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { DatabaseService } from 'src/_services/DatabaseService';
import { ContractorMeetStatusModalComponent } from '../contractor-meet-status-modal/contractor-meet-status-modal.component';
import { BtlExpenseModalComponent } from '../btl-expense-modal/btl-expense-modal.component';
import { UploadFileModalComponent } from 'src/app/upload-file-modal/upload-file-modal.component';
import { BtlApproveHistoryModalComponent } from '../btl-approve-history-modal/btl-approve-history-modal.component';
import { DialogComponent } from 'src/app/dialog.component';
import * as moment from 'moment';
import { sessionStorage } from 'src/app/localstorage.service';
import { Location } from '@angular/common'
import { ToastrManager } from 'ng6-toastr-notifications';


@Component({
  selector: 'app-contractor-meet-list',
  templateUrl: './contractor-meet-list.component.html'
})
export class ContractorMeetListComponent implements OnInit {
  tabActiveType: any = {};
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  length = 0;
  start = 0;
  end = 10;
  inc = 0;
  pageEvent: PageEvent;
  companyType: any;
  login_data: any = {};
  today_date: Date;
  searchData: any;
  backButton: boolean = false;
  data: any = [];
  allCount: any = {};
  contractorMeetListDetail: any = [];
  sendData: any = [];
  report_manager: any = [];
  rsm2: any = [];
  hodList: any = [];
  active_tab: any = 'Pending'
  sub_active_tab: any = 'Pending for Bill'
  assign_login_data: any = [];
  assign_login_data2: any = [];
  view_edit: boolean = true;
  view_add: boolean = true;
  view_delete: boolean = true;
  activePage_count: any;
  loader: boolean = false;
  datanotfound: boolean = false;
  // pagination
  total_page: any;
  pageCount: any;
  page_limit: any = 0;
  pagenumber: any = 1;
  sr_no: number;
  @Input() dataToReceive: any;
  padding0: any;
  hide: any;
  downurl: any;

  constructor(public toast: ToastrManager, public route: ActivatedRoute, public dialog: MatDialog, public location: Location, public dialog1: DialogComponent, public session: sessionStorage, public serve: DatabaseService, public rout: Router) {
    this.downurl = serve.downloadUrl;
    this.page_limit = this.serve.pageLimit
    this.assign_login_data = this.session.getSession();
    this.assign_login_data = this.assign_login_data.value;
    this.assign_login_data2 = this.assign_login_data.data;
    this.assign_login_data = this.assign_login_data.assignModule;
    const index = this.assign_login_data.findIndex(row => row.module_name == 'Event');
    this.login_data = this.session.getSession();
    this.today_date = new Date();
    this.login_data = this.login_data.value;
    this.login_data = this.login_data.data;
    this.getReportManager('');
    // this.searchData = (this.route['params']['_value']);
    // if (this.searchData.selectedUser && this.searchData.selectedDate) {
    //   this.backButton = true;
    //   this.data.date_from = this.searchData.selectedDate;
    //   this.data.created_by = this.searchData.selectedUser;

    //   this.getContractorMeetList();

    // }

    // else {

    //   if (this.login_data.id) {

    //     this.getContractorMeetList();
    //   }
    // }


  }
  ngOnInit() {

    if (this.dataToReceive != undefined) {
      this.padding0 = this.dataToReceive.padding0;
      this.hide = this.dataToReceive.hide;

      console.log(this.dataToReceive.user_id, 'this.dataToReceive.user_id');


      this.sendData.created_by_id = this.dataToReceive.user_id;

      this.getContractorMeetList();
    }
    else {
      this.searchData = (this.route['params']['_value']);
      if (this.searchData.selectedUser && this.searchData.selectedDate) {
        this.backButton = true;
        this.data.date_from = this.searchData.selectedDate;
        this.data.created_by = this.searchData.selectedUser;
        this.getContractorMeetList();
      }
      else {
        this.getContractorMeetList();
      }
    }
    this.data = this.serve.getData()
    if (this.data.status) {
      this.active_tab = this.data.status
    }
    if (this.data.sub_active_tab) {
      this.sub_active_tab = this.data.sub_active_tab
    }
    if (this.data.start) {
      this.start = this.data.start
    }
  }

  selectType(type) {
    this.companyType = type;
    this.getContractorMeetList();
  }

  setPageSizeOptions(setPageSizeOptionsInput: string) {
    if (setPageSizeOptionsInput) {
      this.pageSizeOptions = setPageSizeOptionsInput.split(',').map(str => +str);


    }
  }

  downloadExcel(func_name) {
    this.serve.post_rqst({ 'filter': this.sendData, start: this.start, pagelimit: this.page_limit }, "Excel/" + func_name)
      .subscribe(((result: any) => {
        if (result['msg'] == true) {
          window.open(this.downurl + result['filename'])
          this.getContractorMeetList('');
        } else {
        }
      }));
  }

  openDialog(id): void {
    const dialogRef = this.dialog.open(ContractorMeetStatusModalComponent, {
      width: '500px',
      panelClass: 'cs-modal',
      data: {
        'from': 'Eventplan_modal',
        'event_id': id
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == true) {
        this.getContractorMeetList(this.active_tab);
      }
    });
  }

  pervious() {
    this.start = this.start - this.page_limit;
    this.getContractorMeetList();
  }

  nextPage() {

    this.start = this.start + this.page_limit;
    this.getContractorMeetList();
  }

  open() {
    this.rout.navigate(['/contractor-meet-detail']);
  }

  public DateOfMeeting(event): void {

    this.data.dom_from = moment(event.value).format('YYYY-MM-DD');
    this.getContractorMeetList();
  }


  public onDate(event): void {
    this.data.date_from = moment(event.value).format('YYYY-MM-DD');
    this.getContractorMeetList();
  }


  getContractorMeetList(action: any = '') {
    this.data.status -= this.active_tab
    console.log(this.active_tab, 'this.data.status');
    if(this.active_tab == 'Completed'){
      this.data.sub_status = this.sub_active_tab
    }else{
      this.data.sub_status = undefined;
    }
    console.log(this.data.sub_status, 'this.data.sub_status');
    if (action == "refresh") {
      this.data = {};
      this.contractorMeetListDetail = [];
    }

    if (this.pagenumber > this.total_page) {
      this.pagenumber = this.total_page;
      this.start = this.pageCount - this.page_limit;
    }

    if (this.start < 0) {
      this.start = 0;
    }


    this.sendData = {
      user_id: this.login_data.id,
      created_by_user: this.data.created_by,
      reporting_manager_name: this.data.reporting_manager_name,
      rsm2_name: this.data.rsm2_name,
      hod_name: this.data.hod_name,
      firm_mobile: this.data.firm_mobile,
      created_by_user_email: this.data.email,
      firm_name: this.data.firm_name,
      event_type: this.data.event_type,
      date_from: this.data.date_from,
      dom_from: this.data.dom_from,
      type: this.companyType,
      status: this.active_tab,
      sub_status: this.data.sub_status,
      expense_sharing: this.data.expense_sharing,
      state: this.data.state,
      district: this.data.district,
      event_id:this.data.event_id
    };
    this.loader = true;
    this.serve.post_rqst({ 'filter': this.sendData, start: this.start, pagelimit: this.page_limit }, "Event/eventList").subscribe((result) => {
      if (result['statusCode'] == 200) {
        this.data.status = this.active_tab;
        this.data.sub_active_tab = this.sub_active_tab;
        this.data.start = this.start;
        this.serve.setData(this.data);
        this.contractorMeetListDetail = result['result']['result'];
        this.allCount = result['result']['all_cont'];
        this.length = result['result'].length;
        this.activePage_count = this.allCount[this.active_tab];
        if (this.contractorMeetListDetail.length == 0) {
          this.datanotfound = true
        } else {
          this.datanotfound = false
        }

        if (this.pagenumber > this.total_page) {
          this.pagenumber = this.total_page;
          this.start = this.activePage_count - this.page_limit;
        }
        else {
          this.pagenumber = Math.ceil(this.start / this.page_limit) + 1;
        }
        this.total_page = Math.ceil(this.activePage_count / this.page_limit);
        this.sr_no = this.pagenumber - 1;
        this.sr_no = this.sr_no * this.page_limit;
        this.loader = false;
      } else {
        this.loader = false;
        this.toast.errorToastr(result['statusMsg']);
      }

    }, err => {
      this.loader = false;

      this.toast.errorToastr('Something went wrong');
    })


  }

  refresh() {
    this.data = {};
    this.sendData = {};
    this.pagenumber = 0;
    this.serve.setData(this.data)
    this.getContractorMeetList(this.active_tab);
  }

  statusModal(id, status) {
    const dialogRef = this.dialog.open(ContractorMeetStatusModalComponent, {
      width: '500px',
      panelClass: 'cs-modal',
      data: {
        'id': id,
        'status': status
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getContractorMeetList();
    });
  }
  getReportManager(search, type: any = '') {
    this.serve.post_rqst({ 'search': search }, "Checkin/getSalesUserForReporting").subscribe((result => {
      if (result['all_sales_user']['statusCode'] == 200) {

        if (type == 'hod') {
          this.hodList = result['all_sales_user']['all_sales_user'];
        }
        else if (type == 'rsm1') {
          this.report_manager = result['all_sales_user']['all_sales_user'];
        }
        else if (type == 'rsm2') {
          this.rsm2 = result['all_sales_user']['all_sales_user'];
        } else {
          this.report_manager = result['all_sales_user']['all_sales_user'];
          this.rsm2 = result['all_sales_user']['all_sales_user'];
          this.hodList = result['all_sales_user']['all_sales_user'];
        }
      }
      else {
        this.toast.errorToastr(result['all_sales_user']['statusMsg'])
      }
    }));
  }

  exportAsXLSX() {
    this.loader = true;
    if(this.active_tab == 'Completed'){
      this.data.sub_status = this.sub_active_tab
    }else{
      this.data.sub_status = undefined;
    }
    this.sendData = {
      user_id: this.login_data.id,
      created_by_user: this.data.created_by,
      reporting_manager_name: this.data.reporting_manager_name,
      rsm2_name: this.data.rsm2_name,
      hod_name: this.data.hod_name,
      firm_mobile: this.data.firm_mobile,
      created_by_user_email: this.data.email,
      firm_name: this.data.firm_name,
      event_type: this.data.event_type,
      date_from: this.data.date_from,
      dom_from: this.data.dom_from,
      type: this.companyType,
      status: this.active_tab,
      sub_status: this.data.sub_status,
      expense_sharing: this.data.expense_sharing,
      state: this.data.state,
      district: this.data.district,
    };
    this.serve.post_rqst({ 'filter': this.sendData, 'start': this.start, 'pagelimit': this.page_limit, 'status': this.active_tab }, 'Excel/eventExcel').subscribe((result) => {
      if (result['msg'] == true) {
        this.loader = false;
        window.open(this.downurl + result['filename'])
        this.getContractorMeetList();
      } else {
        this.loader = false;
      }
    });
  }

  statusModal2() {
    const dialogRef = this.dialog.open(ContractorMeetStatusModalComponent, {
      width: '500px',
      panelClass: 'cs-modal',
      data: {
        'from': 'budget_per_plumber',
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == true) this.getContractorMeetList();
    });
  }

  openExpenseModal(eventId) {
    const dialogRef = this.dialog.open(BtlExpenseModalComponent, {
      width: '500px',
      panelClass: 'cs-modal',
      data: {
        'event_id': eventId
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == true) {
        this.getContractorMeetList();
      }
    });
  }

  public getServerData(event: PageEvent) {
    this.sendData = {
      date_created: this.data.date_created,
      created_by_user: this.data.created_by,
      firm_mobile: this.data.firm_mobile,
      created_by_user_email: this.data.email,
      firm_name: this.data.firm_name,
      event_type: this.data.event_type,
      start: this.start,
      page_size: this.pageSize,
      end: this.end,
    };
    if (event.pageIndex != 0) {
      this.inc = 1;

    }
    else {
      this.inc = 0;
    }

    // alert(event.pageIndex);
    this.start = event.pageIndex * 10;
    this.end = (event.pageIndex + 1) * 10;
    this.getContractorMeetList();
  }

  back(): void {
    this.location.back()
  }

  openBulkApproveModal() {
    const dialogRef = this.dialog.open(UploadFileModalComponent, {
      width: '500px',
      panelClass: 'cs-modal',
      data: { from: 'btlBulkApprove', filter: this.sendData }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == true) this.getContractorMeetList();
    });
  }

  openApproveHistoryModal() {
    const dialogRef = this.dialog.open(BtlApproveHistoryModalComponent, {
      width: '900px',
      panelClass: 'cs-modal',
      data: {}
    });
    dialogRef.afterClosed().subscribe(() => {
      this.getContractorMeetList();
    });
  }

}
